import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ActionType, StatusType } from 'src/app/core/enums/enums';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';

@Injectable({
  providedIn: 'root'
})
export class ReportLogService {
  constructor(private itinerary: ItineraryService, private api: APIService) {}
  message = 'Server 502 / Pod Caido / Validar Servidor';

  public Start(action: keyof typeof ActionType) {
    this.Log(action, StatusType.Start);
  }

  public Success(action: keyof typeof ActionType, error?: string) {
    this.Log(action, StatusType.Success, error);
  }

  public FinishByUser(action: keyof typeof ActionType, error?: string) {
    this.Log(action, StatusType.FinishByUser, error);
  }

  public Search(action: keyof typeof ActionType) {
    this.Log(action, StatusType.Search);
  }

  public TimeOut(action: keyof typeof ActionType) {
    this.Log(action, StatusType.TimeOut);
  }

  public failureUser(action: keyof typeof ActionType, error?: string) {
    this.Log(action, StatusType.failureUser, error);
  }

  public successClient(action: keyof typeof ActionType, error?: string) {
    this.Log(action, StatusType.successClient, error);
  }

  public Failure(action: keyof typeof ActionType, error: any) {
    this.Log(
      action,
      StatusType.Failure,
      error?.message
        ? JSON.stringify(error.message)
        : typeof error === 'string'
        ? error
        : JSON.stringify(error)
    );
  }

  private Log(action: keyof typeof ActionType, status: StatusType, error: string = '') {
    let TransactionID: string;
    let errorT = error == '{"isTrusted":true}' ? this.message : error;
    this.itinerary
      .getPnrInfo()
      .pipe(take(1))
      .subscribe({
        next: (form) => {
          TransactionID = form?.transactionId;
        }
      });

    this.itinerary
      .getSearchForm()
      .pipe(take(1))
      .subscribe({
        next: (form) => {
          const params: any = {
            action: ActionType[action],
            status,
            gds: form.gds,
            pnr: form.ticketNumbers?.length ? form.ticketNumbers.toString() : form.pnr,
            transactionId: TransactionID
          };
          if (error) {
            params.error = errorT;
          }

          this.api
            .saveReportLog(params)
            .pipe(take(1))
            .subscribe({
              error: (ex) => {
                console.warn('Unable to save report log.', {
                  body: params,
                  internalError: ex
                });
              }
            });
        },
        error: console.error
      });
  }
}
